import { createTheme } from '@mui/material/styles';

const primaryMain = '#7851A9';
const primaryDark = '#6A1B9A';

const theme = createTheme({
  palette: {
    primary: {
      main: primaryMain,
      light: '#9C27B0',
      dark: primaryDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FF6B35',
      light: '#FF8A65',
      dark: '#E64A19',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F5F6FA',   // Content area slightly contrasted for sidebar distinction
      paper: '#ffffff',     // Cards / surfaces → white
    },
    text: {
      primary: '#000000',   // Black text
      secondary: '#666666', // Grey text
    },
    success: { main: '#4CAF50' },
    warning: { main: '#FF9800' },
    error: { main: '#F44336' },
    info: { main: '#2196F3' },
  },
  typography: {
    fontFamily: '"Outfit", "Lato", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontSize: '1.75rem', fontWeight: 300, color: '#000000' },
    h6: { fontWeight: 500, color: '#000000' },
    body2: { fontSize: '0.875rem', color: '#000000' },
    body1: { color: '#000000' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F5F6FA',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        },
      },
    },
    // ── Navbar ───────────────────────────────────────────────
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: primaryMain,
          color: '#ffffff',
          boxShadow: 'none',
          borderBottom: '1px solid rgba(255,255,255,0.15)',
        },
      },
    },
    // ── Sidebar ──────────────────────────────────────────────
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          borderRight: '1px solid #E0E0E0',
          boxShadow: 'none',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          margin: '2px 10px',
          color: '#333333',
          backgroundColor: 'transparent',
          border: 'none',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: `rgba(120, 81, 169, 0.08)`,
            color: primaryMain,
          },
          '&.Mui-selected, &[aria-current="page"], &.active': {
            backgroundColor: primaryMain,
            color: '#ffffff',
            fontWeight: 700,
            '&:hover': {
              backgroundColor: primaryDark,
            },
            '& .MuiListItemIcon-root': {
              color: '#ffffff',
            }
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '40px',
          color: '#666666',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: { 
          color: 'inherit',
          fontSize: '0.95rem',
          fontWeight: 500,
        },
      },
    },
    // ── Global Button Overrides ──────────────────────────────
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          fontWeight: 600,
          borderRadius: '8px',
          '&:hover': {
            boxShadow: 'none',
          },
          '&:active': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default theme;
